'use client';

import { Input } from '@/components/ui/input';
import useCreateQueryString from '@/hooks/useCreateQueryString';
import useRouterTransition from '@/utils/useRouterTransition';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import useDebounce from '@/hooks/useDebounce';

export default function SearchBar({ labels = {} }) {
  const router = useRouterTransition();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [search, setSearch] = useState(searchParams.get('q') || '');

  const createQueryString = useCreateQueryString(searchParams);

  const debouncedPush = useDebounce(value => {
    const query = createQueryString(['q', value], ['page', 1]);
    router.push(`${pathname}?${query}`);
  }, 500); // 500ms debounce

  useEffect(() => {
    const educationArea = document.querySelector('.education-area');
    if (!educationArea) return;

    if (router.isPending) educationArea.classList.add('opacity-50');
    else educationArea.classList.remove('opacity-50');
  }, [router.isPending]);

  return (
    <div className='mb-8'>
      <Input
        placeholder={labels.search}
        className='max-w-md'
        value={search}
        onChange={event => {
          const value = event.target.value;
          setSearch(value);
          debouncedPush(value);
        }}
      />
    </div>
  );
}
